import { FaArrowLeftLong, FaArrowRightLong } from "react-icons/fa6";
import { Spinner } from "react-bootstrap";
import axiosInstance from "../api/axiosInstance";
import NotificationHeader from "../components/NotificationHeader/NotificationHeader";
import React, { useEffect, useState } from "react";
import SearchBox from "../components/SearchBox/SearchBox";
import toast from "react-hot-toast";

const TwilioNumbers = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredNumbers, setFilteredNumbers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [numbers, setNumbers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const recordsPerPage = 25;
  const totalCount = numbers.length;
  const totalPages = Math.ceil(totalCount / recordsPerPage);

  const startIndex = (currentPage - 1) * recordsPerPage;
  const endIndex = startIndex + recordsPerPage;

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleSearch = (term) => setSearchTerm(term);

  const handleUpdate = async (sid) => {
    setLoading(true);
    try {
      const response = await axiosInstance.put("/message/incomingNumbers", {
        sid,
      });

      if (response?.data?.success) toast.success(response?.data?.message);
      else toast.error(response?.data?.message);
    } catch (error) {
      console.error("🚀 -> fetchAllIncomingNumbers -> error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchAllIncomingNumbers = async () => {
      setLoading(true);
      try {
        const response = await axiosInstance.get("/message/incomingNumbers");

        if (response?.data?.success) setNumbers(response?.data?.data);
        else toast.error(response?.data?.message);
      } catch (error) {
        console.error("🚀 -> fetchAllIncomingNumbers -> error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllIncomingNumbers();
  }, []);

  useEffect(() => {
    if (searchTerm) {
      setFilteredNumbers(
        numbers.filter((number) => number.phoneNumber.includes(searchTerm))
      );
    }
  }, [searchTerm]);

  return (
    <>
      <NotificationHeader name="Developer Administrator" />
      <div className="dashboardPage">
        <div className="container">
          <div className="pageStyle">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-12">
                <SearchBox onSearch={handleSearch} />
              </div>
              <div className="col-lg-6 col-md-6 col-12">
                <div className="text-end"></div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="wordsListBox DevAdmin">
                  <div className="wordsListHeader">
                    <div className="wordListItem">
                      <div className="wordBox">
                        <p>Number</p>
                      </div>
                      <div className="wordBox">
                        <p>Status</p>
                      </div>
                      <div className="wordBox urlBox">
                        <p>URL</p>
                      </div>
                      <div className="wordBox">
                        <div className="actionBox"></div>
                      </div>
                    </div>
                  </div>
                  <div className="wordsListBody">
                    {(searchTerm ? filteredNumbers : numbers)
                      .slice(startIndex, endIndex)
                      .map((number) => (
                        <div className="wordListItem" key={number.sid}>
                          <div className="wordBox">
                            <p>{number.phoneNumber}</p>
                          </div>
                          <div className="wordBox">
                            <p
                              className={`${
                                number.urlStatus === "own"
                                  ? "text-success"
                                  : "text-danger"
                              }`}
                            >
                              {number.urlStatus}
                            </p>
                          </div>
                          <div className="wordBox urlBox">
                            <p>{number.smsUrl}</p>
                          </div>
                          <div className="wordBox">
                            <div className="actionBox">
                              <button
                                disabled={number.urlStatus === "own"}
                                onClick={() => {
                                  handleUpdate(number.sid);
                                }}
                              >
                                Update
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                  <div className="paginationControls">
                    <button
                      disabled={currentPage === 1}
                      onClick={handlePreviousPage}
                      type="button"
                    >
                      <FaArrowLeftLong size={24} />
                    </button>
                    <span className="pageIndicator">
                      Page {currentPage} of {totalPages}
                    </span>
                    <button
                      disabled={currentPage === totalPages}
                      onClick={handleNextPage}
                      type="button"
                    >
                      <FaArrowRightLong size={24} />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {loading && (
          <div
            style={{
              alignItems: "center",
              backgroundColor: "rgba(0, 0, 0, 0.75)",
              display: "flex",
              height: "100vh",
              justifyContent: "center",
              left: 0,
              position: "fixed",
              top: 0,
              width: "100vw",
              zIndex: 1000,
            }}
          >
            <Spinner
              animation="border"
              style={{
                borderWidth: 8,
                height: 100,
                width: 100,
              }}
              variant="light"
            />
          </div>
        )}
      </div>
    </>
  );
};

export default TwilioNumbers;
